import type { ElementType } from 'react'
import {
  ArrowSquareOut,
  Bathtub,
  Bed,
  Bell,
  CalendarBlank,
  Car,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  ChatCircle,
  Check,
  CheckCircle,
  Clock,
  CreditCard,
  CurrencyEur,
  DownloadSimple,
  EnvelopeSimple,
  Funnel,
  GearSix,
  Gift,
  Heart,
  House,
  Info,
  List,
  ListBullets,
  Lock,
  MagnifyingGlass,
  MapPin,
  Minus,
  PencilSimple,
  Phone,
  Plus,
  Printer,
  ShareNetwork,
  ShieldCheck,
  ShoppingCart,
  SignOut,
  SlidersHorizontal,
  Star,
  Ticket,
  Trash,
  UploadSimple,
  User,
  Users,
  Warning,
  WarningCircle,
  WifiHigh,
  X,
} from '@phosphor-icons/react'
import type { IconKey, ThemedIconComponent } from '@/shared/theme/resolveThemedIcon'

export const HORIZON_ICON_REGISTRY = {
  home: House,
  reservation: House,
  calendar: CalendarBlank,
  heart: Heart,
  user: User,
  users: Users,
  bell: Bell,
  cart: ShoppingCart,
  search: MagnifyingGlass,
  filter: Funnel,
  sliders: SlidersHorizontal,
  'map-pin': MapPin,
  star: Star,
  'check-circle': CheckCircle,
  info: Info,
  mail: EnvelopeSimple,
  phone: Phone,
  logout: SignOut,
  settings: GearSix,
  'credit-card': CreditCard,
  ticket: Ticket,
  gift: Gift,
  menu: List,
  list: ListBullets,
  close: X,
  'chevron-left': CaretLeft,
  'chevron-right': CaretRight,
  'chevron-down': CaretDown,
  'chevron-up': CaretUp,
  'arrow-external': ArrowSquareOut,
  shield: ShieldCheck,
  bed: Bed,
  bath: Bathtub,
  clock: Clock,
  euro: CurrencyEur,
  car: Car,
  wifi: WifiHigh,
  share: ShareNetwork,
  download: DownloadSimple,
  upload: UploadSimple,
  print: Printer,
  edit: PencilSimple,
  trash: Trash,
  plus: Plus,
  minus: Minus,
  check: Check,
  warning: Warning,
  'error-circle': WarningCircle,
  'success-circle': CheckCircle,
  lock: Lock,
  chat: ChatCircle,
} satisfies Record<IconKey, ThemedIconComponent>

export const ICON_REGISTRY = HORIZON_ICON_REGISTRY

export type HorizonIconComponent = ElementType
